import { Attributes, DateUtils, Misc, Validation, ValueObject } from '@singularsystems/neo-core';

export default class LadderProjectionPagedCriteria extends ValueObject {

    constructor() {
        super();
        this.makeObservable();
    }
    
    @Attributes.Date(Misc.TimeZoneFormat.None)
    public startDate: Date = DateUtils.monthStart(DateUtils.today());

    @Attributes.Date(Misc.TimeZoneFormat.None)
    public endDate: Date | null = DateUtils.monthEnd(DateUtils.today());

    // Client only properties / methods

    protected static addBusinessRules(rules: Validation.Rules<LadderProjectionPagedCriteria>) {
        super.addBusinessRules(rules);
    }

    public toString(): string {
        return "Ladder Projection Paged Criteria";
    }
}